import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { COVER_IMAGE } from "../data/landing";
import { scrollToSection } from "../utils/scroll";
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="relative overflow-hidden border-b border-line" data-id="element-90" data-mp="9igux7aw3mj4">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-6 py-16 md:py-24 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-91" data-mp="4njng4t9dl8c">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-92" data-mp="xae8p3xwgomv">
          <p className="text-sm text-muted" data-id="element-93" data-mp="s9q8psrp0xgi">
            Manual táctico de gratitud, reprogramación mental y abundancia consciente
          </p>
          <h1 className="mt-5 font-serif text-5xl leading-[1.05] text-cream sm:text-6xl lg:text-7xl" data-id="element-94" data-mp="3d1a83izra9cr">
            Mindset <span className="block text-gold" data-id="element-95" data-mp="381xn73sg3cct">Anti-Fragilidad</span>
          </h1>
          <p className="mt-6 max-w-xl font-serif text-2xl italic leading-snug text-cream/90" data-id="element-96" data-mp="3j8iw0w4jiat4">
            Cómo manifestar abundancia y calma en la Argentina de hoy.
          </p>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-muted" data-id="element-97" data-mp="3o5j2h85axfkr">
            Una guía práctica para recuperar soberanía mental, bajar el ruido interno y entrenar
            una nueva forma de responder ante la incertidumbre. Sin frases vacías ni promesas
            mágicas: para prosperar sin negar la realidad que vivís.
          </p>

          <blockquote className="mt-8 border-l-2 border-emerald pl-5" data-id="element-98" data-mp="358zu4l2bnvp9">
            <p className="font-serif text-xl text-cream" data-id="element-99" data-mp="2qk3kijkmaamj">
              “Tu mente es el único activo que la inflación no puede tocar.”
            </p>
          </blockquote>

          <div className="mt-10 flex flex-col gap-5 sm:flex-row sm:items-center" data-id="element-100" data-mp="2vgu25bc2lea2">
            <a href="#comprar" onClick={event => scrollToSection(event, "comprar", "center")} className="group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-gold px-7 py-4 text-base font-semibold text-ink transition-colors duration-150 hover:bg-gold-light focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-101" data-mp="2hjyp77sp72oq">
              Quiero mi acceso
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-102" data-mp="deyitzlv7va0" />
            </a>
            <div className="text-sm" data-id="element-103" data-mp="162m137zny9th">
              <p className="text-cream" data-id="element-104" data-mp="112g4reig7z52">
                <span className="mr-2 text-muted line-through" data-id="element-105" data-mp="111esj6pp56lr">$10.990</span>
                <span className="text-lg font-semibold" data-id="element-106" data-mp="x1w80c1sexjg">$4.990 ARS</span>
              </p>
              <p className="text-muted" data-id="element-107" data-mp="3ltgmlp4rwont">Precio de lanzamiento · Ebook + 5 bonus</p>
            </div>
          </div>
        </motion.div>

        <motion.figure initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.06
      }} className="relative" data-id="element-108" data-mp="3hqk6q66mb6nk">
          <img src={COVER_IMAGE} alt="El ebook Mindset Anti-Fragilidad abierto en tablet, celular y laptop sobre un escritorio" className="aspect-square w-full rounded-2xl border border-line object-cover" data-id="element-109" data-mp="21b66k5ekreqc" />
        </motion.figure>
      </div>
    </section>;
}